export const ADD_ADMIN_REPORT_DATA = 'ADD_ADMIN_REPORT_DATA'
export const ADD_SUMMARY_ADMIN_REPORT_MANUAL_DATA = 'ADD_SUMMARY_ADMIN_REPORT_MANUAL_DATA'
export const FETCH_AND_ADD_ADMIN_REPORT_DATA = 'FETCH_AND_ADD_ADMIN_REPORT_DATA'
export const FETCH_AND_ADD_SUMMARY_ADMIN_REPORT_MANUAL_DATA = 'FETCH_AND_ADD_SUMMARY_ADMIN_REPORT_MANUAL_DATA'
export const GET_ADMIN_REPORT_DATA = 'FETCH_AND_ADD_ADMIN_REPORT_DATA'
export const GET_SUMMARY_ADMIN_REPORT_MANUAL_DATA = 'GET_SUMMARY_ADMIN_REPORT_MANUAL_DATA'
